import React, { useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { handleDownloadResponse } from '../../util/downloadFile'
import { FlexEndButtonErrorContainer } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import { SecondaryButton } from '../common/Button'

function DownloadLetterButton({ id, name }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  function download() {
    setLoading(true)
    setError(false)
    const fileName = `${name}.pdf`

    axios
      .get(`/letter/${id}/download`, { responseType: 'blob' })
      .then(response => handleDownloadResponse(response, fileName, 'download'))
      .catch(e => {
        setError(true)
        console.error('an error occurred while downloading the letter', name, e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <FlexEndButtonErrorContainer gap="5px">
      <SecondaryButton onClick={download} loading={loading}>
        Download
      </SecondaryButton>
      {error && <ErrorMessage />}
    </FlexEndButtonErrorContainer>
  )
}

DownloadLetterButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default DownloadLetterButton
